var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.shippingTypes),function(shippingType,key){return _c('input',{key:key,attrs:{"name":"shippingType","type":"hidden"},domProps:{"value":key}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }